import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="multiplication"
export default class extends Controller {
  static targets = ["baseNumber", "multiplier", "product"]

  connect() {
    this.calculateProduct();
  }

  calculateProduct() {
    if (!this.hasBaseNumberTarget || !this.hasMultiplierTarget) {
      if (this.hasProductTarget) {
        this.productTarget.value = "";
      }
      return;
    }

    const baseNumber = parseFloat(this.baseNumberTarget.value);
    const multiplier = parseFloat(this.multiplierTarget.value);

    if (this.hasProductTarget) {
      if (isNaN(baseNumber) || isNaN(multiplier)) {
        this.productTarget.value = "";
      } else {
        this.productTarget.value = (baseNumber * multiplier).toFixed(0);
      }
    }
  }
} 